import { useTranslation } from "react-i18next";
import { ApplicantType } from "shared/types";

export const ApplicantRole = ({ role }: { role?: ApplicantType | null }) => {
  const { t } = useTranslation("common");

  if (role === ApplicantType.Occupant) return t("occupant");

  if (role === ApplicantType.CoSigner) return t("guarantor");

  if (role === ApplicantType.Applicant) return t("applicant");

  return "-";
};
